import React, { useState } from 'react';
import { X } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" onClick={onClose} data-id="element-63">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-64">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white" data-id="element-65">
          <h2 className="text-lg font-bold text-dark" data-id="element-66">{title}</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors" data-id="element-67">
            <X className="w-5 h-5 text-gray-500" data-id="element-68" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-sm text-gray-700 leading-relaxed" data-id="element-69">
          {children}
        </div>
      </div>
    </div>;
}
export function LegalFooter() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'disclaimer' | null>(null);
  return <>
      <div className="w-full bg-gray-50 border-t border-gray-200 py-3 text-center" data-id="element-70">
        <p className="text-xs text-gray-500 mb-2" data-id="element-71">
          © {new Date().getFullYear()} Life Freedom. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-72">
          <button onClick={() => setActiveModal('privacy')} className="text-xs text-primary hover:underline font-medium" data-id="element-73">
            Política de Privacidad
          </button>
          <span className="text-gray-300" data-id="element-74">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-xs text-primary hover:underline font-medium" data-id="element-75">
            Términos y Condiciones
          </button>
          <span className="text-gray-300" data-id="element-76">|</span>
          <button onClick={() => setActiveModal('disclaimer')} className="text-xs text-primary hover:underline font-medium" data-id="element-77">
            Descargo de Responsabilidad
          </button>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-78">
        <div className="space-y-4" data-id="element-79">
          <p className="font-semibold" data-id="element-80">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-81">
            <h3 className="font-bold text-base mb-2" data-id="element-82">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-83">
              Recopilamos información personal que usted nos proporciona
              voluntariamente, incluyendo:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1" data-id="element-84">
              <li data-id="element-85">Nombre completo</li>
              <li data-id="element-86">Edad o rango de edad</li>
              <li data-id="element-87">Estado de residencia</li>
              <li data-id="element-88">Número de teléfono</li>
              <li data-id="element-89">Correo electrónico</li>
              <li data-id="element-90">Objetivos financieros</li>
            </ul>
          </section>

          <section data-id="element-91">
            <h3 className="font-bold text-base mb-2" data-id="element-92">
              2. Uso de la Información
            </h3>
            <p data-id="element-93">Utilizamos su información para:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1" data-id="element-94">
              <li data-id="element-95">
                Contactarlo para proporcionarle cotizaciones personalizadas
              </li>
              <li data-id="element-96">Conectarlo con asesores certificados de seguros</li>
              <li data-id="element-97">Mejorar nuestros servicios y experiencia del usuario</li>
              <li data-id="element-98">Cumplir con requisitos legales y regulatorios</li>
            </ul>
          </section>

          <section data-id="element-99">
            <h3 className="font-bold text-base mb-2" data-id="element-100">3. Protección de Datos</h3>
            <p data-id="element-101">
              Implementamos medidas de seguridad de nivel bancario, incluyendo
              cifrado SSL de 256 bits, para proteger su información personal
              contra acceso no autorizado, alteración o divulgación.
            </p>
          </section>

          <section data-id="element-102">
            <h3 className="font-bold text-base mb-2" data-id="element-103">
              4. Compartir Información
            </h3>
            <p data-id="element-104">Podemos compartir su información con:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1" data-id="element-105">
              <li data-id="element-106">Asesores de seguros certificados y autorizados</li>
              <li data-id="element-107">
                Proveedores de servicios que nos ayudan a operar nuestro negocio
              </li>
              <li data-id="element-108">Autoridades cuando sea requerido por ley</li>
            </ul>
          </section>

          <section data-id="element-109">
            <h3 className="font-bold text-base mb-2" data-id="element-110">5. Sus Derechos</h3>
            <p data-id="element-111">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal en cualquier momento. Para ejercer estos derechos,
              contáctenos.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-112">
        <div className="space-y-4" data-id="element-113">
          <p className="font-semibold" data-id="element-114">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-115">
            <h3 className="font-bold text-base mb-2" data-id="element-116">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-117">
              Al utilizar este sitio web y proporcionar su información, usted
              acepta estos términos y condiciones en su totalidad.
            </p>
          </section>

          <section data-id="element-118">
            <h3 className="font-bold text-base mb-2" data-id="element-119">2. Servicios Ofrecidos</h3>
            <p data-id="element-120">
              Life Freedom proporciona servicios de conexión entre consumidores
              y asesores certificados de seguros de vida indexados universales
              (IUL). No somos una compañía de seguros ni vendemos pólizas
              directamente.
            </p>
          </section>

          <section data-id="element-121">
            <h3 className="font-bold text-base mb-2" data-id="element-122">3. Consulta Gratuita</h3>
            <p data-id="element-123">
              La consulta inicial con un asesor es completamente gratuita y sin
              compromiso. No está obligado a comprar ningún producto o servicio.
            </p>
          </section>

          <section data-id="element-124">
            <h3 className="font-bold text-base mb-2" data-id="element-125">
              4. Exactitud de la Información
            </h3>
            <p data-id="element-126">
              Usted se compromete a proporcionar información precisa y
              actualizada. La información inexacta puede afectar las
              cotizaciones y recomendaciones que reciba.
            </p>
          </section>

          <section data-id="element-127">
            <h3 className="font-bold text-base mb-2" data-id="element-128">5. Comunicaciones</h3>
            <p data-id="element-129">
              Al proporcionar su información de contacto, usted acepta recibir
              comunicaciones de Life Freedom y asesores asociados por teléfono,
              correo electrónico o WhatsApp.
            </p>
          </section>

          <section data-id="element-130">
            <h3 className="font-bold text-base mb-2" data-id="element-131">6. Modificaciones</h3>
            <p data-id="element-132">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. El uso continuado del sitio después de cambios constituye
              aceptación de los nuevos términos.
            </p>
          </section>
        </div>
      </Modal>

      {/* Disclaimer Modal */}
      <Modal isOpen={activeModal === 'disclaimer'} onClose={() => setActiveModal(null)} title="Descargo de Responsabilidad" data-id="element-133">
        <div className="space-y-4" data-id="element-134">
          <section data-id="element-135">
            <h3 className="font-bold text-base mb-2" data-id="element-136">Información General</h3>
            <p data-id="element-137">
              La información proporcionada en este sitio web es solo para fines
              informativos generales. No constituye asesoramiento financiero,
              legal o fiscal profesional.
            </p>
          </section>

          <section data-id="element-138">
            <h3 className="font-bold text-base mb-2" data-id="element-139">
              Seguros de Vida Indexados Universales (IUL)
            </h3>
            <p data-id="element-140">
              Los seguros de vida indexados universales son productos
              financieros complejos que pueden no ser adecuados para todos. Los
              rendimientos están vinculados a índices del mercado y pueden
              variar. No hay garantía de rendimientos específicos.
            </p>
          </section>

          <section data-id="element-141">
            <h3 className="font-bold text-base mb-2" data-id="element-142">Riesgos</h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-143">
              <li data-id="element-144">
                Los valores en efectivo pueden fluctuar según el rendimiento del
                índice
              </li>
              <li data-id="element-145">
                Existen tarifas, cargos y limitaciones que pueden afectar el
                rendimiento
              </li>
              <li data-id="element-146">
                Las garantías están respaldadas por la capacidad de pago de la
                compañía emisora
              </li>
              <li data-id="element-147">
                El acceso anticipado a fondos puede resultar en penalidades e
                impuestos
              </li>
            </ul>
          </section>

          <section data-id="element-148">
            <h3 className="font-bold text-base mb-2" data-id="element-149">
              No Somos Asesores Financieros
            </h3>
            <p data-id="element-150">
              Life Freedom actúa como intermediario para conectar consumidores
              con asesores certificados. No proporcionamos asesoramiento
              financiero directo. Todas las recomendaciones provienen de
              asesores independientes licenciados.
            </p>
          </section>

          <section data-id="element-151">
            <h3 className="font-bold text-base mb-2" data-id="element-152">
              Consulte a un Profesional
            </h3>
            <p data-id="element-153">
              Antes de tomar cualquier decisión financiera, le recomendamos
              encarecidamente consultar con un asesor financiero, contador o
              abogado calificado que pueda evaluar su situación personal.
            </p>
          </section>

          <section data-id="element-154">
            <h3 className="font-bold text-base mb-2" data-id="element-155">
              Resultados No Garantizados
            </h3>
            <p data-id="element-156">
              Los ejemplos, testimonios o proyecciones mostradas son
              ilustrativos y no garantizan resultados futuros. El rendimiento
              pasado no es indicativo de resultados futuros.
            </p>
          </section>

          <section data-id="element-157">
            <h3 className="font-bold text-base mb-2" data-id="element-158">
              Limitación de Responsabilidad
            </h3>
            <p data-id="element-159">
              Life Freedom no se hace responsable por decisiones tomadas basadas
              en la información de este sitio o por las acciones de asesores
              independientes. Usted asume toda la responsabilidad por sus
              decisiones financieras.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}